module.exports = __webpack_public_path__ + "static/media/giffTitan.345af819.webm";